document.addEventListener('DOMContentLoaded', function() {
    // Apply initial fade-in animation to the body
    document.body.style.animation = 'fadeIn 0.3s forwards';

    const logoSplash = document.getElementById('logo-splash');
    if (!logoSplash) {
        console.error("Element with ID 'logo-splash' not found");
        return;
    }

    // Ensure the .dotlottie player is accessed after it's fully loaded
    const lottiePlayer = logoSplash.querySelector('dotlottie-player');
    if (!lottiePlayer) {
        console.error("dotLottie player not found inside #logo-splash");
        return;
    }

    const lastVisitTime = localStorage.getItem('lastVisit');
    const now = Date.now();

    // Changed the interval to 10,800,000 milliseconds (3 hours) 10800000
    if (!lastVisitTime || now - parseInt(lastVisitTime, 10) > 108000000000000) {
        logoSplash.style.display = 'flex';

        // Attach event listener for animation completion
        lottiePlayer.addEventListener('complete', () => {
            logoSplash.style.animation = 'fadeOut .4s ease-in-out forwards';
            setTimeout(() => {
                logoSplash.style.display = 'none';
            }, 400);

            localStorage.setItem('lastVisit', now.toString());
        });

        // Explicitly play the .dotlottie animation if it doesn't auto-play
        lottiePlayer.play();
    } else {
        // Calculate the detailed time left until the next animation can be shown
        let msLeft = 10800000 - (now - parseInt(lastVisitTime, 10));
        let hours = Math.floor(msLeft / 3600000);
        msLeft -= hours * 3600000;
        let minutes = Math.floor(msLeft / 60000);
        msLeft -= minutes * 60000;
        let seconds = Math.floor(msLeft / 1000);

        console.log(`Animation will be available again in ${hours} hours, ${minutes} minutes, and ${seconds} seconds.`);
    }
});
